import React from 'react'
import Logo from './WidgetLogo.svg'
import './Header.scss'

export default function renderHeader() {
  return <img src={Logo} className="passport-ui-component__header active-branded" alt="logo" />
}
